import APIAccessor from "services/apiProcessor";
import { SEARCH_API_URL } from "constants/index";

class SearchService {
    protected api: APIAccessor;

    constructor() {
        this.api = new APIAccessor(SEARCH_API_URL);
    };

    public queryOrganization = async (data: {
        organization?: {
            name?: string;
            province?: string;
            tenantCode?: string;
            serviceCode?: string;
        },
        pageSize?: number,
        pageNumber?: number,
        includeFields?: string[],
    }): Promise<any> => {
        const result = await this.api.post({
            path: "/Search/organization/Query",
            data: data,
        });
        return result.data.result;
    };

    public queryUser = async (data: {
        pageSize?: number,
        pageNumber?: number,
        includeFields?: string[],
        user?: {
            id?: string[];
            email?: string[];
            fullName?: string[];
            phoneNumber?: string[];
        }
    }): Promise<any> => {
        const result = await this.api.post({
            path: "/Search/user/Query",
            data: data,
        });
        return result.data.result;
    };

    public geographyQuery = async (data: {
        geography: IGeography,
        pageSize?: number,
        pageNumber?: number,
        includeFields?: string[],
    }) => {
        const result = await this.api.post({
            path: "/Search/geography/Query",
            data: data,
        });
        return result.data.result;
    }

};

export default SearchService;

export interface IGeography {
    name?: string;
    administrative?: number;
    source?: number[];
    fullName?: string;
    countryCode?: string;
    suggestion?: {
        centerGeographyId?: string;
        centerPartnerId?: string;
        distance: number;
        orderByDistance?: number;
    };
    type?: number[];
}